<template>
    <!-- 策略配置详情 -->
    <div class="">
      <v-dialog
      class="popbox"
        name="dialog2"
        v-model="isShow"
        :title="dialogTitle"
        close-on-click-modal
        :modal="true"
        :width="668"
        :show-confirm="false"
        @after-close="handleAfterClose"
        append-to-body
      >
        <v-form ref="form" >
          <v-form-item label="上传时间">
            {{row.created_at}}
          </v-form-item>
          <v-form-item label="更新时间">
            {{row.updated_at}}
          </v-form-item>
          <!-- 2024/2/27 后台马工要求当前版本不显示 -->
          <!-- <v-form-item label="设备类型">
            {{row.dev_type}}
          </v-form-item> -->
          <v-form-item label="升级策略类型">
            {{row.strategy_typeshow}}
          </v-form-item>
          <v-form-item label="源版本" >
            {{row.source_ver}}
          </v-form-item>
          <v-form-item label="目标版本">
            {{row.target_ver}}
          </v-form-item>
          <v-form-item label="策略文件地址">
             <span class="fileUrl">{{row.file_url}} </span>
          </v-form-item>
          <v-form-item label="策略文件hash">
            {{row.file_hash}}
          </v-form-item>
          <v-form-item id="description" class="description" label="备注">
            {{row.memo}}
          </v-form-item>

        </v-form>
      </v-dialog>
    </div>
</template>

  <script>
  export default {
    components: {},
    props:{
      showInputDialog:{
        type:Boolean,
        default: false
      },
      row:{
      type:Object,
      default:()=>{}
      },

    },
    data() {
      return {

        dialogTitle: "详情",
        dialogInput: "",
        isShow:false,
        selectVal: 1,
      };
    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      handleAfterClose() {
        this.$emit('update:showInputDialog',false)
      },
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
    .upgrade-detaiuls .v-form-item .v-form-item__content {
      display: inline-block;
      margin-left: 24px!important;
      max-width: 320px;
    }
  </style>
